import { useEffect } from 'react'

import { useGet } from '../apiHooks'
import { config } from '../../components/Init/Init'
import { useSetCasinoCoinsToFiatRate } from '../../services/store/casinoStore/casinoActions'

export const useGetCoinsToFiatExchangeRate = (playerDataLoading) => {
  const { setCasinoCoinsToFiatRate } = useSetCasinoCoinsToFiatRate()
  const { GET } = useGet()

  useEffect(() => {
    if (config.enableCryptoWallet && playerDataLoading) {
      GET(config.paymentsUrl + config.getCoinsToFiatExchangeRateUrl)
        .then(data => setCasinoCoinsToFiatRate(data))
        .catch(error => console.log('Get coins to fiat exchange rate error', error))
    }
  }, [playerDataLoading])
}
